import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useSelector } from 'react-redux';

WalletCard.propTypes = {
  color: PropTypes.string,
  amount: PropTypes.number,
  currency: PropTypes.string,
  onPressedTopUp: PropTypes.func,
};

function WalletCard({ amount, currency = 'VNĐ', onPressedTopUp, color = AppColors.primary }) {
  // MARK: ---- PROPERTIES ----
  const [amountVisible, setAmountVisible] = useState(false);
  const { permissionList } = useSelector((state) => state.auth);

  return (
    <div
      className="overflow-hidden position-relative"
      style={{
        border: `1px solid ${AppColors.gray[300]}`,
        borderRadius: '10px',
        backgroundColor: color,
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          borderBottomLeftRadius: '10px',
          borderBottomRightRadius: '10px',
          marginBottom: '5px',
        }}
      >
        {/* header */}
        <div
          className="px-4 pt-6 pb-4 d-flex flex-column align-items-start"
          style={{
            borderBottom: `1px dashed ${AppColors.gray[300]}`,
          }}
        >
          <div
            className="p-4"
            style={{
              backgroundColor: color,
              borderRadius: '10px',
            }}
          >
            <i className="fa-solid fa-2x fa-wallet text-white" />
          </div>
          <div className="mt-4">
            <span style={UIHelper.buildFontStyle('700', '20px', AppColors.gray[800])}>
              Thông tin ví
            </span>
          </div>
        </div>
        {/* body */}
        <div className="p-4 d-flex align-items-center justify-content-between">
          <div className="d-flex flex-column align-items-start gap-1">
            {amount !== undefined && !_.isNaN(amount) && (
              <div className="d-flex align-items-center gap-3">
                <span style={UIHelper.buildFontStyle('600', '15px', AppColors.gray[800])}>
                  {amountVisible ? Utils.formatNumber(amount) : '***'} {currency}
                </span>
                <i
                  className={`fa-regular ${amountVisible ? 'fa-eye-slash' : 'fa-eye'
                    } cursor-pointer hover-opacity-60`}
                  style={{ color: AppColors.gray[800] }}
                  onClick={() => {
                    setAmountVisible(!amountVisible);
                  }}
                />
              </div>
            )}
            <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[700])}>Số dư</span>
          </div>
          {Utils.checkPermission(permissionList, AppConstants.permissionCode.driverUpdate.code) &&
            UIHelper.buildGreenButton('Nạp tiền', onPressedTopUp)}
        </div>
      </div>
    </div>
  );
}

export default WalletCard;
